import React from 'react';

import AvailableProducts from './AvailableProducts.js';
import CurrentSelection from './CurrentSelection';
import RangeModal from './RangeModal.js';
import { GridSection } from '../styles';
import SelectorControls from './common/SelectorControls.js';
import MainHeading from './MainHeading.js';
import MobileSelectionDisplay from './Touch/MobileSelectionDisplay.js';

const PickerGrid = ({
  products,
  limit,
  selection,
  handleLimitChange,
  handleRangeSwitch,
  handleAddItem,
  clearSelection,
  updateItemRemove,
  randomise,
  showMessages,
  setShowMessages,
  rangeName,
  singleMessage,
  setSingleMessage,
  handleAddMessage,
  messages,
  disableMessage,
  handleShowMessages,
  handleSingleMessage,
  clearMultiMessage,
  singleMessageContent,
  rangeModalOpen,
  setRangeModalOpen,
  setNewRange,
  newRange,
  setSelection,
  setCurrentRange,
  setLimit,
  isMobile,
  editable,
  setEditable,
  personalisationSelected,
  setPersonalisationSelected,
  expanded,
  setExpanded,
  isMini,
  setIsMini,
  firstMsg,
  setFirstMsg,
  presetMsg,
  setPresetMsg,
  buildBId,
}) => {
  const getCharacterCount = (item) => {

    let count = item?.char_count ? item.char_count : item.character_limit;
    let msg = item?.message ? item.message : false;

    const msgVal = () => {
      let val = 0;
      msg.split('').forEach((letter) => {
        letter.toLowerCase() !== letter ? (val += 2) : val++;
      });
      return val;
    };

    count = msg ? count - msgVal() : count;

    return count;
  };

  return (
    <>
      {rangeModalOpen && (
        <RangeModal
          open={rangeModalOpen}
          oldRange={products}
          newRange={newRange}
          setCurrentRange={setCurrentRange}
          clearSelection={clearSelection}
          rangeModalOpen={rangeModalOpen}
          setRangeModalOpen={setRangeModalOpen}
          setLimit={setLimit}
          setSelection={setSelection}
          limit={limit}
          setIsMini={setIsMini}
          buildBId={buildBId}
        />
      )}
      <div className="row">
        <div className="col-xl-7 col-12">
          <MainHeading />
          {isMobile && (
            <SelectorControls
              isMobile={isMobile}
              handleRangeSwitch={handleRangeSwitch}
              isMini={isMini}
              setIsMini={setIsMini}
              limit={limit}
              sizes={products.box_size}
              handleLimitChange={handleLimitChange}
              randomise={randomise}
              setExpanded={setExpanded}
              expanded={expanded}
            />
          )}

          <AvailableProducts
            products={products}
            handleAddItem={handleAddItem}
            selection={selection}
            updateItemRemove={updateItemRemove}
          />
        </div>
        <GridSection className="col-xl-5 col-12 d-xl-flex d-none py-xl-3 px-xl-5 grid-right">
          {!isMobile && (
            <SelectorControls
              handleRangeSwitch={handleRangeSwitch}
              isMini={isMini}
              setIsMini={setIsMini}
              limit={limit}
              sizes={products.box_size}
              handleLimitChange={handleLimitChange}
              randomise={randomise}
              setExpanded={setExpanded}
              expanded={expanded}
            />
          )}
          <CurrentSelection
            setSelection={setSelection}
            limit={limit}
            selection={selection}
            sizes={products.box_size}
            handleLimitChange={handleLimitChange}
            clearSelection={clearSelection}
            updateItemRemove={updateItemRemove}
            randomise={randomise}
            showMessages={showMessages}
            setShowMessages={setShowMessages}
            charLimit={products.personalisation.max_characters}
            rangeName={rangeName}
            singleMessage={singleMessage}
            setSingleMessage={setSingleMessage}
            handleAddMessage={handleAddMessage}
            messages={messages}
            disableMessage={disableMessage}
            handleShowMessages={handleShowMessages}
            handleSingleMessage={handleSingleMessage}
            clearMultiMessage={clearMultiMessage}
            singleMessageContent={singleMessageContent}
            currentRange={products}
            isMobile={isMobile}
            editable={editable}
            setEditable={setEditable}
            personalisationSelected={personalisationSelected}
            setPersonalisationSelected={setPersonalisationSelected}
            expanded={expanded}
            setExpanded={setExpanded}
            firstMsg={firstMsg}
            setFirstMsg={setFirstMsg}
            presetMsg={presetMsg}
            setPresetMsg={setPresetMsg}
            isMini={isMini}
            getCharacterCount={getCharacterCount}
          />

          {/* <BuyBtn selection={selection} limit={limit} products={products} /> */}
        </GridSection>
        {!!isMobile && (
          <MobileSelectionDisplay
            setSelection={setSelection}
            limit={limit}
            selection={selection}
            sizes={products.box_size}
            handleLimitChange={handleLimitChange}
            clearSelection={clearSelection}
            updateItemRemove={updateItemRemove}
            randomise={randomise}
            showMessages={showMessages}
            setShowMessages={setShowMessages}
            charLimit={products.personalisation.max_characters}
            rangeName={rangeName}
            singleMessage={singleMessage}
            setSingleMessage={setSingleMessage}
            handleAddMessage={handleAddMessage}
            messages={messages}
            disableMessage={disableMessage}
            handleShowMessages={handleShowMessages}
            handleSingleMessage={handleSingleMessage}
            clearMultiMessage={clearMultiMessage}
            singleMessageContent={singleMessageContent}
            currentRange={products}
            isMobile={isMobile}
            editable={editable}
            setEditable={setEditable}
            personalisationSelected={personalisationSelected}
            setPersonalisationSelected={setPersonalisationSelected}
            expanded={expanded}
            setExpanded={setExpanded}
            firstMsg={firstMsg}
            setFirstMsg={setFirstMsg}
            presetMsg={presetMsg}
            setPresetMsg={setPresetMsg}
            isMini={isMini}
            getCharacterCount={getCharacterCount}
          />
        )}
      </div>
    </>
  );
};

export default PickerGrid;
